import { 
  Drawer, 
  List, 
  ListItem, 
  ListItemIcon, 
  ListItemText, 
  Box, 
  Divider, 
  Typography, 
  Tooltip 
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Dashboard as DashboardIcon,
  Subscriptions as SubscriptionsIcon,
  People as PeopleIcon,
  Event as EventIcon,
  VerifiedUser as KYCIcon,
  Person as PersonIcon,
  Settings as SettingsIcon,
  AdminPanelSettings as AdminIcon,
  History as HistoryIcon,
  Payment as PaymentIcon,
  Article as BlogIcon,
  Add as AddIcon,
  EventAvailable as EventMgmtIcon,
  Assignment as PlansIcon,
  DynamicForm as DynamicFieldIcon,
  Image as IconManagementIcon,
  LocalOffer as OfferIcon,
  TrendingUp as OpportunityIcon,
  AccountBalanceWallet as WalletIcon,
  CreditCardOutlined as AssetsIcon,
  Assessment as AssessmentIcon,
} from '@mui/icons-material';
import { useAuth } from '../context/AuthContext';

const Sidebar = ({ open = true, width = 240 }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();

  const menuItems = [
    { text: 'Dashboard', icon: <DashboardIcon />, path: '/dashboard', role: 'all' },
    { text: 'Subscriptions', icon: <SubscriptionsIcon />, path: '/subscriptions', role: 'all' },
    { text: 'Plans', icon: <PlansIcon />, path: '/plans', role: 'all' },
    { text: 'Events', icon: <EventIcon />, path: '/events', role: 'all' },
    { text: 'Blog', icon: <BlogIcon />, path: '/blog', role: 'all' },
    { text: 'Activity History', icon: <HistoryIcon />, path: '/activity-history', role: 'all' },
    { text: 'Profile', icon: <PersonIcon />, path: '/profile', role: 'all' },
  ];

  const adminMenuItems = [
    { text: 'Dashboard', icon: <DashboardIcon />, path: '/dashboard', role: 'all' },
    { text: 'LBK Library', icon: <AssetsIcon />, path: '/LBK Library', role: 'admin' },
    { text: 'User Management', icon: <PeopleIcon />, path: '/users', role: 'admin' },
    {text: 'KYC Verification', icon: <KYCIcon />, path: '/kyc-verification', role: 'admin'},
    // { text: 'Add User', icon: <AddIcon />, path: '/add-user', role: 'admin' },
    { text: 'Blog Management', icon: <BlogIcon />, path: '/blog-management', role: 'admin' },
    { text: 'Event Management', icon: <EventMgmtIcon />, path: '/event-management', role: 'admin' },
    { text: 'Offer Management', icon: <OfferIcon />, path: '/offer-management', role: 'admin' },
    { text: 'Nearby Opportunities', icon: <OpportunityIcon />, path: '/opportunity-management', role: 'admin' },
    { text: 'Subscriptions', icon: <SubscriptionsIcon />, path: '/subscription-management', role: 'admin' },
    { text: 'LBK Wallet', icon: <WalletIcon />, path: '/lbk-wallet', role: 'admin' },
    { text: 'Reports & Requests', icon: <AssessmentIcon />, path: '/reports-requests', role: 'admin' },
    { text: 'Payments', icon: <PaymentIcon />, path: '/payments', role: 'admin' },
    { text: 'Dynamic Fields', icon: <DynamicFieldIcon />, path: '/dynamic-fields', role: 'admin' },
    { text: 'Icon Management', icon: <IconManagementIcon />, path: '/icon-management', role: 'admin' },
    { text: 'System Config', icon: <AdminIcon />, path: '/system-configuration', role: 'admin' },
    { text: 'Users Activity', icon: <HistoryIcon />, path: '/Users Activity', role: 'admin' },
    { text: 'Settings', icon: <SettingsIcon />, path: '/settings', role: 'admin' },
  ];

  const isAdmin = user?.isAdmin === true || user?.role === 'SYSTEM_ADMIN';

  const renderListItem = (item) => {
    const isSelected = location.pathname === item.path;
    const listItem = (
      <ListItem
        component="div"
        key={item.text}
        onClick={() => navigate(item.path)}
        sx={{
          minHeight: 48,
          justifyContent: open ? 'initial' : 'center',
          px: 2.5,
          cursor: 'pointer',
          backgroundColor: isSelected ? 'primary.light' : 'transparent',
          color: isSelected ? 'primary.main' : 'inherit',
          '&:hover': {
            backgroundColor: isSelected ? 'primary.light' : 'action.hover',
          },
        }}
      >
        <ListItemIcon
          sx={{
            minWidth: 0,
            mr: open ? 3 : 'auto',
            justifyContent: 'center',
            color: isSelected ? 'primary.main' : 'inherit',
          }}
        >
          {item.icon}
        </ListItemIcon>
        <ListItemText 
          primary={item.text} 
          sx={{ opacity: open ? 1 : 0 }} 
        />
      </ListItem>
    );

    // Wrap with Tooltip when sidebar is collapsed
    if (!open) {
      return (
        <Tooltip key={item.text} title={item.text} placement="right">
          {listItem}
        </Tooltip>
      );
    }

    return listItem;
  };

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: width,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        boxSizing: 'border-box',
        ...(open && {
          '& .MuiDrawer-paper': {
            width: width,
            transition: (theme) => theme.transitions.create('width', {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.enteringScreen,
            }),
          },
        }),
        ...(!open && {
          '& .MuiDrawer-paper': {
            width: 60,
            transition: (theme) => theme.transitions.create('width', {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.leavingScreen,
            }),
            overflowX: 'clip',
          },
        }),
      }}
    >
      <Box sx={{ overflow: 'clip', mt: 8 }}>

        {!isAdmin && (
           <List>
            {menuItems.map(renderListItem)}
          </List>
        )}
       
        
        {isAdmin && (
          <List>
            {adminMenuItems.map(renderListItem)}
          </List>
        )}
      </Box>
    </Drawer>
  );
};

export default Sidebar;